import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  schedule: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  scheduleItem: {},
  summaryList: {
    data: [],
    total: 0,
    is_more: false,
    last_page: 1,
    loader: false,

  }
}

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState: initialState,
  reducers: {
    setScheduleItem: (state, { payload }) => {
      state.scheduleItem = payload?.data ?? payload;
    },
    setSchedules: (state, { payload }) => {
      state.schedule = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
    },
    setScheduleSummary: (state, { payload }) => {
      state.summaryList.data = payload?.data || [];
      state.summaryList.total = payload?.total || 0;
      state.summaryList.is_more = payload?.is_more || false;
      state.summaryList.last_page = payload?.last_page || 0;
    },
    setSummaryLoader: (state, { payload }) => {
      state.summaryList.loader = payload
    },
    setMoreSchedules: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeSchedule: (state, { payload }) => {
      state.error = payload
    },
    clearAllSchedule: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }




export const addLunchSchedule = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addLunchSchedule(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setSchedule(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const addSchedule = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addSchedule(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setSchedule(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateSchedule = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateSchedule(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setSchedule(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeSchedule = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeSchedule(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setSchedule(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchSchedules = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {


    const result = await Api.fetchSchedules(page, params);
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setSchedules(result.data.data));
      } else {
        dispatch(setSchedules(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}
export const fetchScheduleSummaryList = (page, params, disableLoader) => async (dispatch) => {
  dispatch(setSummaryLoader(true))
  try {


    const result = await Api.fetchScheduleSummaryList(page, params);
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setScheduleSummary(result.data?.data));
      } else {
        dispatch(setScheduleSummary(result.data?.data));
      }

    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))

    }
    else{
    }
  } catch (error) {
    console.log("error", error)


  }
  dispatch(setSummaryLoader(false))
}

export const fetchScheduleView = (id, disableLoader) => async (dispatch) => {
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchScheduleView(id);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setScheduleItem(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  dispatch(setLoader(false))
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "schedule")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleSchedules = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleSchedules(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setScheduleItem, setSchedules, clearAllSchedule, setLoader, setSummaryLoader, setError, setMoreSchedules, setScheduleSummary } = scheduleSlice.actions


export default scheduleSlice.reducer
export const scheduleSelector = state => state.schedule


